import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRouteStore = defineStore('routes', () => {
  // --- UI State only ---
  const selectedRouteId = ref<number | null>(null);

  const clearSelection = () => {
    selectedRouteId.value = null;
  };

  const setSelectedRoute = (id: string | number) => {
    const routeId = typeof id === 'string' ? Number.parseInt(id, 10) : id;
    selectedRouteId.value = Number.isFinite(routeId) ? routeId : null;
  };

  return {
    selectedRouteId,
    clearSelection,
    setSelectedRoute,
  };
});
